import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Page from 'components/Page';
import { useLanguage } from 'context/AppContext';
import DeliveryPortalMenu from '../molecules/DeliveryPortalMenu';
import FileUpload from '../molecules/FileUpload';

const DeliveryPortalUploadPage: React.FC = () => {
  const [language] = useLanguage();

  return (
    <Page>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" component="h1">
              {language.DeliveryPortal.FileUpload.title}
            </Typography>
          </Grid>
          <Grid item>
            <DeliveryPortalMenu />
          </Grid>
        </Grid>
        <Box mb={4} />
        <FileUpload />
      </Box>
    </Page>
  );
};

export default DeliveryPortalUploadPage;
